// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class PurchaseOrderShipAddress extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  id!: number;
  address1?: string;
  address2?: string;
  city?: string;
  companyName?: string;
  deleted?: Date;
  displayOrder?: number;
  name?: string;
  phone?: string;
  state?: string;
  zip?: string;
}

